module.exports = __webpack_public_path__ + "static/media/ButtonEnterSize13.2f495e6b.png";